import {AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChange} from '@angular/core';
import {PointOfSaleDto} from "../../point-of-sale-dto";
import {TranslateService} from "@ngx-translate/core";
import {NotificationService} from "../../../../root/toast/notification.service";
import {CookieService} from "ngx-cookie";
import {GAService} from "../../../../root/ga/ga.service";

@Component({
    selector: 'orlando-instructions',
    templateUrl: './orlando-instructions.component.html',
    providers: []
})
export class OrlandoInstructionsComponent implements OnInit, AfterViewInit{

    @Input() errors;
    @Input() dto:PointOfSaleDto;
    @Input() countryId;
    @Input() isValidLocation

    errorMeetingPointRequired:boolean;
    showModalNewDeliveryPoint:boolean = false;
    currentMeetingPoints:any[] = Array();

    ITEMS_PER_PAGE:number = 5;
    pages:any[] = Array();
    currentPage:number=1;
    totalItems:number;
    itemsPerPage:number;
    totalPages:number;
    mapMeetingPointPerPage = new Map();
    MODAL_ORLANDO_DELIVERY_INSTRUCTIONS = "modal_delivery_instructions";
    PHONE_PREFIX:string = "+1 ";
    FREE_LINE:string[] = ["800","888","877","866","855","844","833"];
    GA_NOTIFY_CATEGORY = "Autos_MCO_Indications";

    constructor(private translator:TranslateService,
                private notificationService:NotificationService,
                private cookies: CookieService,
                private gaService: GAService){

    }

    ngAfterViewInit(): void {
        if(this.totalPages > 1){
            document.getElementById("link_page_1").classList.add("-active");
        }
    }

    ngOnInit(): void {
        this.dto.pickupIndications.meetingType = "RENTAL_SHUTTLE";
        if(!this.dto.pickupIndications.orlandoAirportPositions){
            this.dto.pickupIndications.orlandoAirportPositions = Array();
        }
        this.setupPages();
        this.openModalOrlandoDeliveryIndications();
    }

    ngOnChanges(changes:  {[propKey: string]: SimpleChange}): void {
        const currentErrors = changes['errors'] ? changes['errors'].currentValue : undefined;
        this.errorMeetingPointRequired = currentErrors && currentErrors.meetingPointsRequired;
        if(this.isValidLocation===false) {
            this.dto.pickupIndications.orlandoAirportPositions = Array();
        }
    }

    showTableDeliveryPoints():boolean {
        return this.dto.pickupIndications.orlandoAirportPositions && this.dto.pickupIndications.orlandoAirportPositions.length > 0;
    }

    showOrlandoModalNewDeliveryPoint(){
        this.errorMeetingPointRequired = false;
        this.showModalNewDeliveryPoint = true;
    }

    closeModalHandler(value){
        this.showModalNewDeliveryPoint = value;
    }

    meetingPointAddedHandler(value){
        this.setupPages();
    }

    getDescriptionForTerminal(terminal:any){
        let textTerminal = "";
        if(terminal.stop){
            textTerminal = terminal.stop;
        }else{
            textTerminal += terminal.range.minValue + this.translator.instant("pickupPoint.table.delivery_points.stop_until") + terminal.range.maxValue;
        }
        return textTerminal;
    }

    nextPage(){
        if(this.currentPage < this.totalPages){
            this.currentPage++;
            this.clearSelectedPage();
            this.currentMeetingPoints = this.mapMeetingPointPerPage.get(this.currentPage);
        }
    }

    previousPage(){
        if( this.currentPage > 1){
            this.currentPage--;
            this.clearSelectedPage();
            this.currentMeetingPoints = this.mapMeetingPointPerPage.get(this.currentPage);
        }
    }

    goToPage(page: any): void{
        this.clearSelectedPage();
        const pageToGo:number = Number(page.currentTarget.text);
        this.currentPage = pageToGo;
        this.currentMeetingPoints = this.mapMeetingPointPerPage.get(pageToGo);
    }

    deleteMeetingPoint(meetingPoint:any){
        let meetingPointFound = this.dto.pickupIndications.orlandoAirportPositions.filter(value => value.id === meetingPoint.id)[0];
        let index = this.dto.pickupIndications.orlandoAirportPositions.indexOf(meetingPointFound);

        if(index !== -1){
            this.dto.pickupIndications.orlandoAirportPositions.splice(index,1);
            this.setupPages();

            if(this.totalPages > 1){
                this.currentPage = 1;
            }
        }
        this.gaService.notify(this.GA_NOTIFY_CATEGORY, "list", ["remove"]);
    }

    setupPages(): void{
        if(this.dto.pickupIndications.orlandoAirportPositions){
            this.setIDs();
            const totalPagesAux = this.totalPages;
            this.totalPages = Math.ceil(this.dto.pickupIndications.orlandoAirportPositions.length / this.ITEMS_PER_PAGE);

            if(this.totalPages > 1){
                //initialize array of pages for pagination purpose (page 1 to N)
                this.pages = Array.from(Array(this.totalPages), (_, i) => i+1);
                this.clearSelectedPage();

                for (let page=1; page <= this.totalPages; page++){
                    const startPosition = (page * this.ITEMS_PER_PAGE) - this.ITEMS_PER_PAGE;
                    const endPosition = startPosition + this.ITEMS_PER_PAGE;
                    this.mapMeetingPointPerPage.set(page, this.dto.pickupIndications.orlandoAirportPositions.slice(startPosition, endPosition));
                }

                //elements of the first page
                this.currentMeetingPoints = this.mapMeetingPointPerPage.get(1);

                if(totalPagesAux !== this.totalPages){
                    this.currentPage = 1;
                }
            }else {
                this.pages = null;
                this.currentPage = 1;
                this.currentMeetingPoints = this.dto.pickupIndications.orlandoAirportPositions;
            }
        }
    }

    setIDs(){
        for (let i=0;i < this.dto.pickupIndications.orlandoAirportPositions.length; i++){

            const point = this.dto.pickupIndications.orlandoAirportPositions[i];

            this.dto.pickupIndications.orlandoAirportPositions[i] = {
                id:i,
                terminal:point.terminal,
                stop: point.stop,
                range:point.range
            };
        }
    }

    hidePagination():boolean {
        return (!this.pages || this.pages.length == 0);
    }

    private clearSelectedPage(){
        for (let i=1; i <= this.totalPages; i++){
            if(document.getElementById(`link_page_${i}`)){
                document.getElementById(`link_page_${i}`).classList.remove("-active");
            }
        }
    }

    isPageSelected(pageSelected:number){
        return this.currentPage == pageSelected;
    }

    openModalOrlandoDeliveryIndications(){
        let modalCookie = this.cookies.get(this.MODAL_ORLANDO_DELIVERY_INSTRUCTIONS);

        if (!modalCookie) {
            this.cookies.put(this.MODAL_ORLANDO_DELIVERY_INSTRUCTIONS, '2');
            this.showModalOrlandoDeliveryIndications(true);

        }else if(parseInt(modalCookie) > 0){
            this.cookies.put(this.MODAL_ORLANDO_DELIVERY_INSTRUCTIONS, (parseInt(modalCookie) - 1).toString());
            this.showModalOrlandoDeliveryIndications(true);
        }
    }

    closeModalOrlandoDeliveryIndications(gotIt: boolean) {
        this.gaService.notify(this.GA_NOTIFY_CATEGORY, "modal", [gotIt ? "confirm" : "close"]);

        if (gotIt) this.cookies.put(this.MODAL_ORLANDO_DELIVERY_INSTRUCTIONS, '0');

        this.showModalOrlandoDeliveryIndications(false);
    }

    showModalOrlandoDeliveryIndications(val){
        let modal = document.getElementById("modalOrlandoDeliveryIndications");

        if(val){
            modal.classList.add("-show-modal")
        }else{
            modal.classList.remove("-show-modal");
        }
        return modal.className;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/delivery-instructions/orlando-instructions/orlando-instructions.component.ts